var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _clipPath, _clipPath2, _clipPath3, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _circle, _circle2, _circle3, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g2, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g3, _g4, _g5, _path76, _path77, _path78, _circle10, _path79, _circle11, _circle12, _text, _circle13, _circle14, _text2, _circle15, _circle16, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 487.9 366.2",
    viewBox: "0 0 487.9 366.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f68ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aceed"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 42.546,
    x2: 134.0496,
    xlinkHref: "#a",
    y1: 280.3987,
    y2: 280.3987
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 86.0859,
    x2: 140.659,
    y1: 130.7958,
    y2: 130.7958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f87b58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8c548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c51"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 86.1661,
    x2: 171.5236,
    y1: 180.5303,
    y2: 121.1207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7658f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1a1ed"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 82.3001,
    x2: 134.7648,
    y1: 142.7475,
    y2: 142.7475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b44be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bd3ef"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 348.7526,
    x2: 403.6012,
    xlinkHref: "#a",
    y1: 271.132,
    y2: 271.132
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 336.0365,
    x2: 410.4936,
    y1: 146.0442,
    y2: 146.0442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87b58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f89453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f8c548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c51"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 333.0836,
    x2: 411.785,
    y1: 172.623,
    y2: 172.623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1a1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7658f4"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 362.4299,
    x2: 388.6291,
    y1: 97.7154,
    y2: 97.7154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aceed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4f68ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282d3"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377.2 119.6h8.4v13.7h-8.4z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m381.2 144.9h23.3v40.5h-23.3z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.7 207.2h19v144.8h-19z"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b449"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 148.6315,
    x2: 114.9227,
    xlinkHref: "#m",
    y1: 67.0105,
    y2: 42.5167
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93764"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 129.4366,
    x2: 142.4348,
    xlinkHref: "#o",
    y1: 42.0131,
    y2: 42.0131
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 126.6265,
    x2: 140.4618,
    xlinkHref: "#m",
    y1: 41.9296,
    y2: 21.3215
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 129.5839,
    x2: 142.4845,
    xlinkHref: "#o",
    y1: 27.8522,
    y2: 27.8522
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 138.3155,
    x2: 147.423,
    xlinkHref: "#m",
    y1: 23.8466,
    y2: 10.2779
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1074,
    x2: 148.9409,
    xlinkHref: "#o",
    y1: 14.5859,
    y2: 14.5859
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 122.961,
    x2: 129.4803,
    xlinkHref: "#m",
    y1: 24.3771,
    y2: 14.668
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 124.1032,
    x2: 130.7103,
    xlinkHref: "#o",
    y1: 17.7399,
    y2: 17.7399
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.3 88.6h17.9v16.7h-17.9z",
    fill: "#e1e6fb",
    transform: "matrix(.7071 -.7071 .7071 .7071 -60.6182 47.6515)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.2 103.6h17.9v16.7h-17.9z",
    fill: "#e1e6fb",
    transform: "matrix(.7071 -.7071 .7071 .7071 -67.1305 61.9437)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.2 73.6h17.9v16.7h-17.9z",
    fill: "#e1e6fb",
    transform: "matrix(.7071 -.7071 .7071 .7071 -45.036 55.2755)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m435.3 289.6h17.9v16.7h-17.9z",
    fill: "#e1e6fb",
    transform: "matrix(.7071 -.7071 .7071 .7071 -80.6132 401.3893)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m449.2 304.6h17.9v16.7h-17.9z",
    fill: "#e1e6fb",
    transform: "matrix(.7071 -.7071 .7071 .7071 -87.1183 415.6787)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m434.2 319.6h17.9v16.7h-17.9z",
    fill: "#e1e6fb",
    transform: "matrix(.7071 -.7071 .7071 .7071 -102.1206 409.4664)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m124.8 27.2h122v63h-122z",
    fill: "#bac5f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m51.8 263.2h46v102h-46z",
    fill: "#e1e6fb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m73.8 272.2s-40-65-42-82-4-23-4-23 12-2 16 7 16-2 20 22c0 0 1 12 10 8s0 68 0 68z",
    fill: "#e1e6fb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m78.8 282.2s-28.6-53-38-74c-7-15.6-13-41-13-41s-12.1 4.4-11 14c1 9-8 12-6 23 2.2 11.9 19.4 14.1 9 25-6.3 6.6-1.6 17.8 3 25 2.9 4.6 17.4 8.8 14 7-7.8-4 42 21 42 21z",
    fill: "#bac5f4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8,
    cy: 214.2,
    fill: "#bac5f4",
    rx: 2,
    ry: 26,
    transform: "matrix(.9084 -.4182 .4182 .9084 -85.0054 40.4529)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m87.4 314.7s-60.9-46-68.9-61.1-12.1-20-12.1-20 10.5-6.2 17.5.7 14.2-7.7 26.6 13.2c0 0 1.4 14.7 10.4 11.7 9.2-3.1 26.5 55.5 26.5 55.5z",
    fill: "#e1e6fb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m95.7 322.2s-45.9-39-62.3-55.1c-12.2-12-27-33.5-27-33.5s-9.6 8.5-5.2 17c4.2 8-3.1 14.1 2.8 23.6 6.3 10.3 23.2 6.1 17.5 20-3.5 8.4 5 17.2 11.9 22.2 4.4 3.2 19.4 1.8 15.6 1.4-8.8-.8 46.7 4.4 46.7 4.4z",
    fill: "#f8f8ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.9,
    cy: 281.5,
    fill: "#e1e6fb",
    rx: 2,
    ry: 26,
    transform: "matrix(.6942 -.7198 .7198 .6942 -191.0347 113.3618)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m404.8 192.3s47.5-77.3 50.6-97.9 5.6-27.8 5.6-27.8-13.2-3-18.1 7.8-17.6-3.1-23.2 25.9c0 0-1.7 14.6-11.5 9.3s-3.4 82.7-3.4 82.7z",
    fill: "#e1e6fb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m398.8 204.2s34.3-63.2 45.8-88.3c8.5-18.6 16.4-49.3 16.4-49.3s13.2 5.9 11.5 17.5c-1.6 10.9 8.3 15 5.5 28.3-3 14.4-22.2 16.3-11.2 30 6.6 8.3.9 21.8-4.6 30.3-3.5 5.4-19.7 9.9-15.9 7.9 8.8-4.5-47.5 23.6-47.5 23.6z",
    fill: "#bac5f4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m432.3 121.7c-7.3 15.6-12.3 28.7-11.2 29.3s7.9-11.5 15.2-27.1 12.3-28.7 11.2-29.4-7.9 11.6-15.2 27.2z",
    fill: "#bac5f4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m387.6 243.4s69.8-53.2 79.4-71.3 14.4-23.8 14.4-23.8-11.3-8-19.4.1-15.3-10-30.2 14.9c0 0-2.2 17.8-12.1 13.7-10.1-4.1-32.1 66.4-32.1 66.4z",
    fill: "#f8f8ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m378.1 252.2s52.8-45.4 71.8-64.3c14.1-14 31.6-39.5 31.6-39.5s10.2 10.8 4.9 21c-5.1 9.6 2.7 17.3-4.2 28.6-7.5 12.2-26 6.4-20.3 23.6 3.4 10.4-6.4 20.7-14.3 26.5-5 3.7-21.6 1.3-17.3 1 9.5-.8-52.2 3.1-52.2 3.1z",
    fill: "#e1e6fb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m448.2 199.4c-11.4 12.2-20 22.8-19.2 23.8s10.8-8.1 22.2-20.3 20-22.8 19.2-23.8-10.8 8.1-22.2 20.3z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m105.8 263.2h77v102h-77z",
    fill: "#bac5f4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m273.8 264.2h77v102h-77z",
    fill: "#e1e6fb"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m253.8 27.2h50v64h-50z",
    fill: "#e1e6fb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m70.8 80.2h349v257h-349z",
    fill: "#bac5f4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m79.8 80.2h340v257h-340z",
    fill: "#f8f8ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m82.8 84.2h333v18h-333z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m82.8 101.2h333v232h-333z",
    fill: "#e1e6fb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m137.8 110.2h41v46h-41z",
    fill: "#bac5f4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m183.8 110.2h41v46h-41z",
    fill: "#bac5f4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m228.8 110.2h41v46h-41z",
    fill: "#bac5f4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m274.8 110.2h41v46h-41z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m319.8 110.2h41v46h-41z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m365.8 110.2h41v46h-41z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m137.8 163.2h41v46h-41z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m183.8 163.2h41v46h-41z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m228.8 163.2h41v46h-41z",
    fill: "#f8f8ff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m274.8 163.2h41v46h-41z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m319.8 163.2h41v46h-41z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m365.8 163.2h41v46h-41z",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m137.8 214.2h41v46h-41z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m183.8 214.2h41v46h-41z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m228.8 214.2h41v46h-41z",
    fill: "#f8f8ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m274.8 214.2h41v46h-41z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m319.8 214.2h41v46h-41z",
    fill: "#f8f8ff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m365.8 214.2h41v46h-41z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m138.8 266.2h41v46h-41z",
    fill: "#f8f8ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m184.8 266.2h41v46h-41z",
    fill: "#f8f8ff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m229.8 266.2h41v46h-41z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m275.8 266.2h41v46h-41z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m320.8 266.2h41v46h-41z",
    fill: "#bac5f4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m366.8 266.2h41v46h-41z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.3,
    cy: 93.7,
    fill: "#bac5f4",
    r: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.3,
    cy: 93.7,
    fill: "#bac5f4",
    r: 3.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.3,
    cy: 93.7,
    fill: "#bac5f4",
    r: 3.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m97.3 162.2h28c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5h-28c-2.5 0-4.5-2-4.5-4.5 0-2.4 2-4.5 4.5-4.5z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m97.3 214.2h28c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5h-28c-2.5 0-4.5-2-4.5-4.5 0-2.4 2-4.5 4.5-4.5z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m97.3 266.2h28c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5h-28c-2.5 0-4.5-2-4.5-4.5 0-2.4 2-4.5 4.5-4.5z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m145.3 166.2h16c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5h-16c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5z",
    fill: "#bac5f4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m144.3 179.2h7c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-7c-1.4 0-2.5-1.1-2.5-2.5 0-1.3 1.1-2.5 2.5-2.5z",
    fill: "#bac5f4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m191.8 166.2h16c1.7 0 3 1.3 3 3s-1.3 3-3 3h-16c-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3z",
    fill: "#bac5f4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m327.8 273.2h16c1.7 0 3 1.3 3 3s-1.3 3-3 3h-16c-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m372.8 219.2h16c1.7 0 3 1.3 3 3s-1.3 3-3 3h-16c-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3z",
    fill: "#f5f5fc"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m371.8 167.2h16c1.7 0 3 1.3 3 3s-1.3 3-3 3h-16c-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3z",
    fill: "#f5f5fc"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m326.8 167.2h16c1.7 0 3 1.3 3 3s-1.3 3-3 3h-16c-1.7 0-3-1.3-3-3 0-1.6 1.3-3 3-3z",
    fill: "#f5f5fc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bac5f4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192.8,
    cy: 180.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.8,
    cy: 173.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.8,
    cy: 173.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.8,
    cy: 223.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.8,
    cy: 223.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.8,
    cy: 274.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.8,
    cy: 274.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.8,
    cy: 275.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.8,
    cy: 275.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.8,
    cy: 119.2,
    r: 4
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.8,
    cy: 119.2,
    fill: "#fff",
    r: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.8,
    cy: 119.2,
    fill: "#fff",
    r: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.8,
    cy: 119.2,
    fill: "#fff",
    r: 4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.8,
    cy: 119.2,
    fill: "#fff",
    r: 4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.8,
    cy: 119.2,
    fill: "#fff",
    r: 4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.8,
    cy: 119.2,
    fill: "#fff",
    r: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'RevaloModernBold'",
    fontSize: 28
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(298.27 151.936)"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    transform: "translate(209.27 151.936)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(162.61 203.736)"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(289.6 203.796)"
  }, "10"), /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(247.25 255.566)"
  }, "15"), /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(382.25 257.566)"
  }, "18"), /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(195 304.956)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#bac5f4",
    transform: "translate(206.73 304.956)"
  }, "0"))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m139.3 353.3c-1.7-1.1-3.6-2.4-8.4-3.4-4-.7-6.3-6.9-6.3-6.9h-9.2s-.8 10.3-.4 11.1.6 1.7 2.8 2.4c2.1.6 20.8.4 21.6.2.7-.1 3-1.4-.1-3.4z",
    fill: "#4b49bb"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m32.2 254.5c-1.2 1.8-6.7 19.7-6.7 20.6-.1.9.4 3.4 3.2 1.1 1.5-1.3 3.4-2.7 5.7-7.1 1.9-3.5 8.5-4 8.5-4l2.8-8.7s-9.6-3.9-10.5-3.8-1.8.1-3 1.9z",
    fill: "#4b49bb"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m92.8 222.1c-.2.1-.5 1.8-.6 2-1.4 4.4-14.2 43.4-14.2 45 0 1.7-27.5-10.8-31.9-12.7-.4-.2-.7 0-.9.3-.9 1.9-3.4 7.5-2.5 8.2 1.1.8 30 21.4 32.4 22s5.9 3.5 11.8-3.5c5.1-6.1 19.3-29.1 23.2-35.6.2-.3.6-.4.9-.2.2.1.3.3.4.5.7 6.2 1 30.2 3.1 36.7 2.1 6.4-.9 13.3-.9 22.8l1.7 34.8c0 .4.3.6.6.6l8 .2c.4 0 .6-.2.7-.6.5-5.6 5.8-47.7 6.3-54.2.6-7.1 4-66.6 3.1-70.2-.7-2.3-36.8 3.2-41.2 3.9z",
    fill: "url(#b)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m95.8 117.4s2-8 3.6-8 11.3 1.2 12.5 6.9 5.6 8.9 5.6 15.7c0 6.9 2.8 10 2.8 10s3.2-10.1 5.6-14.5 6.6-7.1 6.6-10.1-3.5-36.5-3.8-37.4-1.2-6.2.9-9.2c0 0 6.4-5.3 7.2-7.4.6-1.8 2.7-2.8 3.9-.7s-3.7 7.7-4.5 9.9c-.7 2.1-1.2 4.3-1.5 6.6 0 .6-1.2 9.5-1.2 13.9s2.7 18.4 2.7 22.9c0 4.4-9.8 22.2-10.7 25.5s-29.4 34.4-30 35.3-3.5 7.7-3.5 10.1 0 10.1 1.2 8.6 6.1-13.3 7-14.8 7.9-2.9 11.2-3.8 8.2.9 7.6 3-10.2 6-13.3 6.7c-1.9.5-10.4 9.8-11 12.5s-8.3-1.2-8.3-5 .9-23.4 2.1-26.1 6.6-14.2 9.5-20.2c3-6-3.5-8.9-4.7-13.1-1.5-4.1 2.5-17.3 2.5-17.3z",
    fill: "url(#c)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m121.3 136.4s7.7-13.9 8.5-17.4-1.2-39.1-1.2-39.1l6-.9s5.7 33 6.5 36.9c.8 3.8-2 12.1-4.7 16.8s-10 24.2-10 26.5.5 24.2 1.7 28.5 6 30.7 6 30.7l-41.3 3.9s1.8-11.5 1.7-15.4c-.3-8.4-2.6-14.7 3.5-18.7 4.1-2.6 8-1.4 12.5-3.5 5.1-2.5 6.3-4.6 6.6-6 .2-.8-1.1-2.7-9.1.2-2.7 1-8 .9-8.2 4.4-.1 2.9 3.7 9.2-.8 12 0 0-5.1 12.1-9.9 14-4.1 1.6-9-2.8-8.9-8.5.1-6.9.5-20 3.7-25.7 3.1-5.7 11.7-20.4 13.2-21.6s6.2 4.4 11.6 3.7c5.4-.8 7.7-3.3 8.9-6 1.1-2.8 3.7-14.8 3.7-14.8z",
    fill: "url(#d)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m104 111.1c2.4 3.9 5.6 7.3 9.2 10 6.3 4.8.1 18.3-.2 25-.2 5.4 3 12.8 10.7 17.8 5.6 3.7 1.7 11.9 1.7 16.1 0 4.1 9-5.8 9.3-10.6.4-5.8-1.1-10-5.2-14.7-3.8-4.4-8.3-21-9.6-28.9-.1-.8-.2-1.6-.1-2.4.1-2.8-.2-11.6-8.2-16.5-9.5-5.9-15.4-.5-19.2 2.8-4.7 4-6.6 15-5.4 32.1s-1.8 26.9-3.8 31.8c-4.6 11.3 7.9 3.4 10.2-3.1 3-8.3 5-9 9.2-15.5 1.7-2.5-.5-11.2-2.4-14.8-3.5-7-5.5-9.9-5.5-14.6s5.8-12.7 9.3-14.5z",
    fill: "url(#e)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m105.9 141.7s6.7.4 8.5-3.8c.2-.5-1.1 13-1.4 11.2-.5-1.8-7.1-7.4-7.1-7.4z",
    opacity: 0.07
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m94.1 172.9s-1.5 9.6-2.4 13.9c-.5 2.4-.8 4.7-.8 7.1 0 0 5.7-7.1 7.5-9.9 1.1-1.8-2.3-.9-2.6-7.4s-.2-10.6-.2-10.6z",
    opacity: 0.07
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m94.6 203.6s5.1-5 5.3-7.6c.3-3.4 2.7-3.2 2.7-1.1s-3.8 18-1.5 22.2 4.1 4.1 4.1 4.1l-12.4.9z",
    opacity: 0.07
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m105.2 221.2s.7 12.6-3.8 16.8c-9.2 8.6-3.8 19.8-7.9 24.7-3.4 4.1-4.3 15.8-12.5 18.4-3.2 1.1-14.9-6.1-17.3-6.9-5-1.7-8.6-11.3-24.2-16.3-3.7-1.2 9.6.1 9.6.1l28.9 12 14.9-47.8z",
    opacity: 0.07
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m370.4 334.2h-1.4l-7.5.1s-1.6 7.7-2.5 10.9c0 .2-.2.7-.3 1.1-.1.6-.2 1.1-.2 1.7.2 2.9 1.2 5.4 3.9 6.7 2.9 1.4 5.1 2.8 8.1 0s3.5-4.5 2.3-9.4c-1.3-4.8-1.7-11-2.4-11.1z",
    fill: "#4b44be"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m401.9 343.8c-5.2-1.6-8.7-8.7-8.7-8.7l-8.9-.5s-.5 7.2-.7 10.8c-.3 4.8.5 7 3.7 6.7 4.2-.3 21.2 1.2 23.9-.5 3.5-2.3-4.5-6.3-9.3-7.8z",
    fill: "#4b44be"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m348.8 207v10.6l12.8 116.7h9.1s3.1-80 3.1-82.8.8-11.5.8-11.5 11.4 32.9 11.6 35.6-1.9 59.4-1.9 59.4l9.1.4s7.9-38.3 7.9-41.9 2.7-22.5 2.3-26.1-7.1-60-7.1-60l-13.9-.4z",
    fill: "url(#f)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m407.5 194.7-.1-.2c0 .2 0 .3.1.2m-26.6-10.2-5.1 2.1-.3 7 5.6 2.2s6.1-.2 6.1-.3c0-.3 2.4-.2 3.5.5l19-6.5.7-4.5s1.4 5.7-4.9-5.8zm22.6-23.1-.4-2.3-1-.2zm-35-61c-2.3 1-3.5 4.4-3.5 4.4s-1.1-.7-1.1 1.2 1 6.3 1.6 7.4c1.2 1.9 2.3 3.8 3.3 5.8.9 2 .6 6.1-.4 6.7s-18.2 16.1-18.2 16.1l-14.2 43.7v1.7l2.2.8 2.3 1.9c.2 0 3.1 1.6 3.5 1.9 2.3 1.1 4.7 2 7.1 2.5 1.6.3 8.7.2 8.7.2l7.2-.2-1.2-9.2-10.7-.1-14.6-.7 14.8-34 46.6 8.3c-8.3-15-17.6-31.8-18.4-33.6-.7-1.4 0-4.9.4-6.7.4-1.6 1.2-3.7 1.9-4.3.8-.6 2.1-3.3 2.1-4.4s.3-5.7-.6-4.7c-.3.3-1.4-1.4-1.8-3.2-.6-2.5-2.4-4.3-4.4-5.9 0 0-10.3 3.4-12.6 4.3",
    fill: "url(#g)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m350.6 132.7c-2.3 1.5-4.3 3.6-5.1 6.2-.8 2.7-6.2 23.3-6.9 26-1.8 6.4-2.8 8.2-4.9 15.8-2.6 9.3 3.3 10.7 9.4 12 6.3 1.4 6.3 2 7.8 2 .2 0 7.7 1.5 7.9-2.7.2-2.7-.3-6.9-1.3-6.8-2.3.3-9.7-1.6-10.1-1.9-.5-.3 1.6-6.1 2.8-9.7.9-2.7 4.3-13.7 5.1-15.7.4-1.1-1.9 10.7-3.3 22.3 0 .4-.6 4.9-.4 4.9 1.7 0 6.3.1 7.8.2 6.5.8 7.8 3.9 7.4 6.4-.7 4.3-16.6 2.3-16.5 2.9 0 0-2.7 12.3-1.2 13.1 1.3.7 19.1 8.1 22.9 9.5.4.2.9 0 1-.5l2.4-6.9c0-.1.1-.1.2-.1 0 0 .1 0 .1.1l2.3 7.6c0 .2.2.4.4.4h1l19.8-4.3s-.1-7.8-.1-17.8c0-1-.2-4.7-.9-4s-17.2 2.9-19 2.1c-3.8-1.6-2.8-5.6-1.5-7.2 1.5-1.9 21-2.8 21.1-4.2.3-6.1-.2-22.2-.5-20.2-.5 3-11.9 19.5-11.9 22.4s-.2 10.1-.2 10.1l18.7-1.4s6.3-2.2 6.8-5.8c.6-3.6-.1-5.2-.4-10.6-.2-3.4-5-24-6.4-29.8-.2-.9-.3-1.8-.4-2.7-.2-2.4-1.1-8-6.3-10.5-6.4-3.1-11.5-5.5-12.8-5.5-1.2 0-4.5 7.2-6.2 9.3-.8.9-.6 1.4-1.6 2.7-.5.7-1.5.8-2.2.4-.2-.1-.3-.3-.4-.4-.6-.8-1-1.7-1.5-2.6-.8-1.5-6.7-10.3-6.7-10.3s-13.9 3.6-16.2 5.2",
    fill: "url(#h)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m381.1 96.1s-12.6 4.7-13.5 5.4-2.6 3.3-2.6 3.3-.9-.5-1.1.8c0 0-1.3-2.7-1.4-4.1-.2-1.5 0-5.3 2.4-7.8s7.3-5.9 10.3-5.4c3 .4 4.3.8 6.2 2.7s3.5 2.5 4.1 2.7c.6.3 2.7 1.9 3.1 4.8s-.6 8.8-.6 8.8.3-2.3-.6-1.6c-.6.5-1.6-1.6-1.9-2.9-.5-1.2-3.7-6.3-4.4-6.7z",
    fill: "url(#i)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "m385.3 128.3c-.1-.2 1.4.8-.3-.4-2.4-1.7-1.2-8.8-1.2-8.8-.9 1.9-2.4 3.3-4.3 4-3 1.1-3.9.3.7 3s2.2 3.6 1.9 7.1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "m394.6 153.4 6.3 23.8s0 4.2-1.3 4.9c-1.2.6-5.2 1-6.1 1.4s-10.5 2.4-8-1c.6-.8 13.6-5.3 7.8-10.1s-4.8-11.4-2-16 2.2-8.5 2.2-8.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "m368 216.1s-5.4 28.8-2.6 40.3c4.3 17.5-1.9 41.1-1.9 52.4 0 7.4 2.9 27.7 3.1 36 0 2.5 1.9 7.3.5 8.5-.6.5-4-.6-5.9-1.5-1-.5-1.6-1.5-1.4-2.6l1.1-4.9 1.6-6.5-11.3-105.4s-3.6-23.5-1.6-23.5c2.1-.2 18.4 7.2 18.4 7.2"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m362.8 177.3 21.3 2.7c.4.1.7.5.7 1l-.6 19.2c0 .6-.4 1.4-1 1.2l-21.2-4.1c-.4-.1-.7-.5-.7-.9l-.1-2.1 2.3-.6c.6-.2 1.2-.5 1.6-.8.1-.1.2-.2.3-.3l.5-.7c.2-.2.2-.5.2-.8-.1-.4-.2-1-.3-1.4 0-.1-.1-.2-.1-.3l-.5-1.1c-.2-.5-.6-.9-1.2-1.2l-.3-.2-2.3-1.2.2-7.5c0-.5.4-.9 1-.9z",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m112.1 52.9 4.9-.3s1-5.9 4.9-7.8v-6.5s4.6 2.6 5.5 2.9c1 .3 9.8-3.9 19.8 2.3 8.5 5.2 6.6 14.3 5.8 17.1-.1.5-.4 1-.7 1.4-.7 1-2.1 2.9-2.8 3.6-1 1 .6 6.4-.7 6.8-1 .3-2.9-3.9-3.9-3.6-5.2 1.8-10.9 2-16.3.5-.4-.1-.7.1-.9.4-.4.9-1.3 2.5-2 3-1 .7-1-3.6-2-4.2s-11.7-10.1-11.7-10.1v-5.5z",
    fill: "url(#n)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m152.9 53.9s4-2.8 6.1-.7 1.8 4.3.1 4.8c-1.3.4-3.3-1.8-2.4-3.1s2.4-2.1 4.1-1 2.5 3.5 2.6 4.8",
    fill: "none",
    stroke: "#f93764",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 53.3,
    fill: "#f7b14a",
    r: 1.8
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m130 42.3s7.3-2 12 .2",
    fill: "none",
    stroke: "url(#p)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.1,
    cy: 27.8,
    fill: "url(#q)",
    r: 7.3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 27.9,
    fill: "none",
    r: 6,
    stroke: "url(#r)",
    strokeMiterlimit: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#f9b449",
    fontFamily: "'ArialMT'",
    fontSize: 8.6848,
    transform: "translate(133.6808 30.5892)"
  }, "$")), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.6,
    cy: 14.6,
    fill: "url(#s)",
    r: 4.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 14.6,
    fill: "none",
    r: 3.9,
    stroke: "url(#t)",
    strokeMiterlimit: 10
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#f9b449",
    fontFamily: "'ArialMT'",
    fontSize: 5.7162,
    transform: "translate(142.9709 16.387)"
  }, "$")), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.4,
    cy: 17.7,
    fill: "url(#u)",
    r: 3.4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.4,
    cy: 17.7,
    fill: "none",
    r: 2.8,
    stroke: "url(#v)",
    strokeMiterlimit: 10
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#f9b449",
    fontFamily: "'ArialMT'",
    fontSize: 4.0904,
    transform: "translate(126.3 19.0433)"
  }, "$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg41);
export default __webpack_public_path__ + "static/media/bg4-1.3423a943ce9866429fe1e5e797d1f1e9.svg";
export { ForwardRef as ReactComponent };